<template>
  <div
    id="enterprises"
    class="row"
  >
    <v-btn
        color="primary"
        dark
        @click="openModalAyuda()"
        block
    >
        ¿Ayuda para crear el archivo de importar empresas? Click Aquí
    </v-btn>
    <v-dialog
      v-model="dialogAyuda"
      max-width="700"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Necesitas ayuda para crear el archivo de importación?
        </v-card-title>
        <v-card-text>
          El archivo debe ser excel (xls o xlsx) con un máximo de 200Kb y/o 100 líneas.
        </v-card-text>
        <v-card-text>
          La cabecera deberá ser en el siguiente orden.
        </v-card-text>
        <v-card-text>
          Tipo de Contribuyente | RUC | DV | Ubigeo | Razón Social | Nombre Comercial |
          Correo Electrónico | Teléfono | Sucursal | Dirección | Provincia | Distrito | Corregimiento
        </v-card-text>
        <v-card-text>
          Descargue el archivo de ejemplo <a style="color: blue !important" @click="getExcel()">aquí</a>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="red darken-1"
            text
            @click="dialogAyuda = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row
      justify="center"
      v-show="loadComplete"
    >
      <v-sheet
        v-show="loadComplete"
        :color="`grey lighten-4`"
        class="justify-center w-100 h-100"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="article, actions"
          boilerplate
        />
      </v-sheet>
    </v-row>
    <v-row
      justify="center"
      v-show="!loadComplete"
    >
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeyDown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              :color="color"
              color-button-cancel="white"
              color-button-save="white"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              class="wrap justify-space-around form-body"
            >
              <!-- <v-col
                cols="12"
                md="12"
              >
                <v-select
                  v-model="form.type_enterprise"
                  :items="items_type"
                  :rules="[rules.required]"
                  label="Tipo de Empresa"
                  placeholder="FEL o PAC"
                  required
                />
              </v-col> -->
              <v-col
                cols="12"
                md="12"
              >
                <v-file-input
                  v-model="form.file"
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Seleccione para agregar un archivo excel (xls o xlsx) "
                  type="file"
                  ref="file"
                  id="file"
                  @change="selectFile"
                  :rules="[rules.required]"
                  :disabled="form.busy"
                  required
                />
              </v-col>
              <v-col
                v-if="form.busy"
                cols="12"
                md="12"
              >
                <v-alert
                  type="warning"
                  prominent
                  border="left"
                  colored-border
                  elevation="2"
                  class="mb-4"
                >
                  <v-row align="center">
                    <v-col class="grow">
                      <div class="text-h6">
                        <v-icon left color="warning">mdi-information-outline</v-icon>
                        ¡Proceso en curso!
                      </div>
                      <div class="text-body-1 mt-2">
                        <strong>No actualice el navegador.</strong> Por favor espere
                        a que el proceso de importación termine. Esto puede tomar
                        varios minutos dependiendo del tamaño del archivo.
                      </div>
                    </v-col>
                  </v-row>
                </v-alert>
                <v-card outlined class="pa-4">
                  <div class="text-subtitle-1 mb-2">
                    {{ progressLabel }}
                  </div>
                  <v-progress-linear
                    :value="displayProgress"
                    :indeterminate="!isUploading"
                    color="#0083cb"
                    height="24"
                    rounded
                    class="mb-2"
                  >
                    <template v-if="isUploading">
                      <strong>{{ Math.round(displayProgress) }}%</strong>
                    </template>
                  </v-progress-linear>
                  <div class="text-caption text--secondary">
                    {{ progressHint }}
                  </div>
                </v-card>
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
      <v-col
        v-if="end"
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-card>
          <v-tabs
            v-model="tab"
            color="primary"
            centered
            icons-and-text
          >
            <v-tab href="#tab-1">
              Errores
              <v-icon>mdi-close-thick</v-icon>
            </v-tab>
            <v-tab href="#tab-2">
              Exito
              <v-icon>mdi-check-bold</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
              value="tab-1"
            >
              <v-card flat>
                <v-card-text
                  v-for="error in errors" :key="error.ruc">
                    {{(error.error === undefined)?`·
                    El RUC ${error.ruc}, Razón social ${error.name}, Sucursal ${error.branch_code}.`:
                        `·  ${error.error}
                        El RUC ${error.ruc}, Razón social ${error.name}, Sucursal ${error.branch_code}.`}}
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              value="tab-2"
            >
              <v-card flat>
                <v-card-text v-for="(save, index) in saves" :key="`${save.ruc}-${save.branch_code}-${index}`">
                  {{ `· Creado con éxito: RUC ${save.ruc}, Razón Social ${save.name}, Sucursal ${save.branch_code}.` }}
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from 'vform';
import { format, parseISO } from 'date-fns';
import FormToolbar from '~/components/Form/Toolbar';

export default {
  components: {
    FormToolbar,
  },
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  data: () => ({
    form: new Form({
      id: '',
      type_enterprise: '1',
      file: null,
      busy: false,
    }),
    exist: false,
    loading: false,
    color: '#0083cb',
    loadComplete: true,
    valid: false,
    items_type: [
      { value: '1', text: 'FEL' },
      { value: '3', text: 'PAC' },
    ],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
    },
    buttons: [
      {
        icon: 'mdi-content-save',
        name: 'Guardar',
      },
      {
        icon: 'mdi-close',
        name: 'Cancelar',
      },
    ],
    title: 'Importar Empresas',
    apiURL: '/api/enterprises/import',
    method: 'POST',
    dialogAyuda: false,
    end: false,
    saves: null,
    errors: null,
    tab: 'tab-1',
    uploadProgress: 0,
  }),
  computed: {
    ref() { return this.form.id; },
    displayProgress() {
      return Math.min(this.uploadProgress, 99);
    },
    isUploading() {
      return this.uploadProgress < 100;
    },
    progressLabel() {
      return this.isUploading ? 'Subiendo y procesando archivo...' : 'Procesando datos, espere...';
    },
    progressHint() {
      return this.isUploading
        ? 'Cargando archivo al servidor...'
        : 'Importando empresas en la base de datos. No cierre esta ventana.';
    },
  },
  mounted() {
    this.form.busy = false;
    this.loadComplete = false;
  },
  methods: {
    store() {
      const formData = new FormData();
      formData.append('file', this.form.file);
      formData.append('type_enterprise', this.form.type_enterprise);
      this.uploadProgress = 0;

      window.axios({
        method: this.method,
        url: this.apiURL,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          } else {
            this.uploadProgress = 50;
          }
        },
      })
        .then((response) => {
          this.uploadProgress = 100;
          if (response.data.type === 'success') {
            this.end = true;
            this.saves = response.data.save;
            this.errors = response.data.error;
            this.form.file = null;
            if (response.data.file !== undefined && response.data.file !== null) {
              this.downloadFileExcelError(response,
                  `Errores Importar Empresas ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`, 'xlsx');
            }
          }
          this.snackbar = false;
          this.form.busy = false;
        })
        .catch(() => {
          this.form.busy = false;
        })
        .finally(() => {
          this.uploadProgress = 0;
          this.snackbar = false;
          this.form.busy = false;
        });
    },
    cancel() {
      this.$router.go(-1); // someValue
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    save() {
      this.validate(); // someValue
    },
    validate() {
      this.end = false;
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        if (!this.exist) {
          this.store();
        } else {
          this.$store.dispatch('notifications/show', {
            message: 'Ya existe una empresa con esos datos',
            type: 'error',
          });
          this.snackbar = false;
          this.form.busy = false;
        }
      }
    },
    selectFile(file) {
      this.form.file = file;
    },
    openModalAyuda() {
        this.dialogAyuda = true;
    },
    getExcel() {
        const name = 'Ejemplo_Importar_Empresas';
        const url = '/api/enterprises/download_example';
        window.axios.get(url, { responseType: 'blob' }).then((response) => {
          this.busy = true;
          if (response.data) {
            this.downloadFileExcel(response, `${name}`);
            setTimeout(() => { this.dowloading = false; }, 1000);
              this.$store.dispatch('notifications/show', {
              message: 'Se ha descargado el Excel con éxito.',
              type: 'success',
            });
            this.busy = false;
          } else {
            this.$store.dispatch('notifications/show', {
              message: 'El documentos no contiene Excel.',
              type: 'error',
            });
            this.busy = false;
          }
        })
        .catch(() => {
        });
    },
    downloadFileExcel(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xls`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    downloadFileExcelError(response, filename, extension) {
      const link = document.createElement('a');
      link.href = response.data.file;
      link.download = `${filename }.${extension}`;
      link.click();
    },
  },
};
</script>
<style>
.example {
  border-right: 1px solid black;
  border-collapse: collapse;
}
</style>
